import {IWizardOtherOccupant, IWizardPet, IWizardVehicle} from '../../../models/application-form'
import {createLocalApplicationPersonId} from '../../common/applicationPersonUtils'

export const createEmptyPet = (): IWizardPet => ({
  type: '',
  breed: '',
  isAssistanceAnimal: false,
})

export const createEmptyVehicle = (): IWizardVehicle => ({
  makeModel: '',
  registrationNumber: '',
})

export const createEmptyOtherOccupant = (): IWizardOtherOccupant => ({
  clientId: createLocalApplicationPersonId('occupant'),
  name: '',
  // An explicit blank prevents a remounted registered input from falling back
  // to the previous occupant's age in the form's default values.
  age: '',
  relationship: '',
})
